import { useMemo, useState } from "react";
import DataTransformsDrawer from "../../components/Drawers/DataTransformsDrawer";
import { useAtom } from "jotai";
import { schemaAtom } from "../../atoms/GlobalAtoms";
import { DataTransforms } from "../../types/TenantInterfaces";
import IconButton from "../../elements/IconButton";
import useDeleteDataTransforms from "../../api/api-hooks/modules/useDeleteDataTransforms";
import BasicTableView from "../supportal/CloudListView/BasicTableView";
import AppEmptyState from "../../elements/AppEmptyState";

const DataTransformsView = ({ searchQuery }: { searchQuery: string }) => {
  const [isopen, setisopen] = useState(false);
  const [schema] = useAtom(schemaAtom);
  const [currentDT, setCurrentDT] = useState<DataTransforms>();

  const dataTransforms = useMemo(() => {
    const out = schema?.CRM?.Modules.reduce((acc: any, module) => {
      if (module?.DataTransforms && module?.DataTransforms?.length > 0) {
        acc[module.Name] = module.DataTransforms;
      }
      return acc;
    }, {});
    if (Object.keys(out).length <= 0) return null;
    return out;
  }, [schema?.CRM?.Modules]);

  const filteredDataTransforms = useMemo(() => {
    if (!dataTransforms) return null;
    return Object.keys(dataTransforms).reduce((acc: any, module) => {
      if (module.toLowerCase().includes(searchQuery.toLowerCase())) {
        acc[module] = dataTransforms[module];
      }
      return acc;
    }, {});
  }, [dataTransforms, searchQuery]);

  return (
    <>
      {dataTransforms ? (
        <>
          {Object.keys(filteredDataTransforms).length > 0 ? (
            Object.keys(filteredDataTransforms || dataTransforms).map(
              (module) => {
                return (
                  <DataTransformsCard
                    key={`${module}-data-transforms-card`}
                    title={module}
                    dataTransforms={dataTransforms[module]}
                    setDT={(dt: DataTransforms) =>
                      setisopen(() => {
                        setCurrentDT(dt);
                        return true;
                      })
                    }
                  />
                );
              }
            )
          ) : (
            <AppEmptyState
              title="No Data Transforms"
              description="Get started by adding your first transform"
              className="mt-4"
              icon="mdi-account-convert-outline"
            />
          )}
        </>
      ) : (
        <AppEmptyState
          title="No Data Transforms"
          description="Get started by adding your first transform"
          className="mt-4"
          icon="mdi-account-convert-outline"
        />
      )}

      {currentDT && (
        <DataTransformsDrawer
          closeDrawer={() => {
            setCurrentDT(undefined);
            setisopen(false);
          }}
          open={isopen}
          key={currentDT?.id || "no-dt-drawer"}
          dataTransform={currentDT}
          mode="edit"
        />
      )}
    </>
  );
};

const DataTransformsCard = ({
  title,
  dataTransforms,
  setDT,
}: {
  title: string;
  dataTransforms: DataTransforms[];
  setDT: (dt: DataTransforms) => void;
}) => {
  const { deleteDataTransforms } = useDeleteDataTransforms();

  return (
    <BasicTableView
      items={dataTransforms}
      title={title}
      getItemTitle={(item) => item.SourceModule}
      getItemSubtitle={(item) => item?.Name}
      CustomRenderer={(item) => {
        return (
          <div>
            <IconButton
              icon="pencil"
              tooltipText="Edit Data Transform"
              onClick={() => setDT(item)}
            />
            <IconButton
              icon="close"
              tooltipText="Delete Data Transform"
              onClick={() =>
                deleteDataTransforms({
                  moduleAPIName: item.SourceModule,
                  dtID: item.id,
                })
              }
              color="danger"
            />
          </div>
        );
      }}
      loading={false}
    />
  );
};

export default DataTransformsView;
